const SocialData =[
    {
        platform: 'Instagram',
        link: 'https://www.instagram.com/mahbub_hossain_faisal/',
        icon: require('../../assets/icons/instagram.png'),

    },
    {
        platform: 'Facebook',
        link: 'https://www.facebook.com/mahbub.hossain.334/',
        icon: require('../../assets/icons/facebook.png'),

    },
    {
        platform: 'LinkedIn',
        link: 'https://www.linkedin.com/in/mahbub-hossain-faisal-101/',
        icon: require('../../assets/icons/linkedin.png'),

    },
    {
        platform: 'Github',
        link: 'https://github.com/MahbubHossainFaisal',
        icon: require('../../assets/icons/github.png'),

    },
    {
        platform: 'Pinterest',
        link: 'https://www.pinterest.com/mahbubhossain686/',
        icon: require('../../assets/icons/pinterest.png'),

    },


]

export default SocialData